import S from './center-block.styles';

export const CenterBlock = S.StyledCenterBlock;
